import Vue from 'vue'
import Vuex from 'vuex'
import {PERIOD_MONTHLY, types as profileTypes} from "@/data/profile"
import {isDev} from "@/helpers";

Vue.use(Vuex);

const getDefaultProfile = () => {
  return {
    vector: null,
    type: null,
    name: null,
    size: null,
    consumption: null,
    consumption_type: PERIOD_MONTHLY,
    cost: null,
    cost_type: PERIOD_MONTHLY
  }
};

const getDemoProfile = () => {
  return {
    vector: null,
    type: null,
    name: null,
    size: 12,
    consumption: 12,
    consumption_type: PERIOD_MONTHLY,
    cost: 12,
    cost_type: PERIOD_MONTHLY
  }
};

export default new Vuex.Store({
  state: {
    profile: isDev() ? getDemoProfile() : getDefaultProfile(),
    last_profile_UUID: null,
    subscriber_email: isDev() ? 'assistenza@comodolab.it' : null,
    newsletter_subscription: false
  },
  mutations: {
    newReport(state) {
      state.profile = getDefaultProfile();
    },
    setProfileVector(state, vector){
      state.profile.vector = vector;
    },
    setProfileType(state, type) {
      state.profile.type = type;
      state.profile.name = profileTypes.find(p => p.value === type).text;
    },
    updateProfile(state, payload) {
      state.profile = {
        ...state.profile,
        ...payload
      };
    },
    setProfileUUID(state, uuid) {
      state.last_profile_UUID = uuid;
    },
    setSubscriberEmail(state, email) {
      state.subscriber_email = email;
    },
    setNewsletterSubscription(state, newsletter) {
      state.newsletter_subscription = newsletter;
    }
  },
  actions: {}
})
